<template>
  <div data-v-d27b4d60="" data-v-e5781868="" class="myAccount mainContent top50">
    <div data-v-d27b4d60="" class="content">
      <div data-v-d27b4d60="" class="top zeroLevel">
        <div data-v-d27b4d60="" class="box" style="width: 100%; background-image: url('https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/static/img/normal-1.2721da08.png')">
          <div data-v-d27b4d60="" class="box-inner">
            <div data-v-d27b4d60="" class="username">
              <div data-v-d27b4d60="" class="text">
                尊敬的 <span data-v-d27b4d60="" style="margin-left: 5px">{{ $store.state.userInfo.username }}</span>
              </div>
            </div>
            <div data-v-d27b4d60="" class="bottom-section">
              <div data-v-d27b4d60="" class="group">
                <div data-v-d27b4d60="" class="inputGroup">
                  <label data-v-d27b4d60="">CNY账户</label>
                  <input data-v-d27b4d60="" type="text" :value="$store.state.userInfo.balance" disabled />
                  <span data-v-d27b4d60="" class="current"
                    ><svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon greenDot">
                      <use data-v-338e1447="" xlink:href="#icon-greenDot"></use>
                    </svg>
                    使用中
                  </span>
                </div>
                <div data-v-d27b4d60="" class="help">
                  <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon iconHelp">
                    <use data-v-338e1447="" xlink:href="#icon-iconHelp"></use>
                  </svg>
                  <div data-v-d27b4d60="" class="message">请选择一种资产进行游戏</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-d27b4d60="" class="nav">
        <ul data-v-d27b4d60="">
          <a href="javascript:void(0);" @click="$parent.goNav('/accountSetting')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconSetting">
                <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
              </svg>
              账户设置
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/myWallet')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              我的钱包
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/transfer')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              转账
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')">
            <li data-v-d27b4d60="" class="active">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              资金记录
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/activityRecord')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              活动及代理
            </li>
          </a>
        </ul>
      </div>
      <div data-v-119184d8="" data-v-d27b4d60="" class="fundingRecords">
        <div data-v-119184d8="" class="top">
          <div data-v-119184d8="" class="topTxt">
            <div data-v-119184d8="" class="menu">
              <span data-v-119184d8="" @click="changshowtype(0)" :class="showtype == 0 ? 'active' : ''"> 资金明细 </span>
              <span data-v-119184d8="" @click="changshowtype(1)" :class="showtype == 1 ? 'active' : ''"> 投注记录 </span>
              <span data-v-119184d8="" @click="changshowtype(2)" :class="showtype == 2 ? 'active' : ''"> 返水记录 </span>
              <span data-v-119184d8="" @click="changshowtype(3)" :class="showtype == 3 ? 'active' : ''"> 红包记录 </span>
              <div data-v-119184d8="" style="display: none">
                <span data-v-119184d8="" class="operation">编辑</span>
                <div data-v-119184d8="" style="display: none">
                  <span data-v-119184d8="" class="operation">取消</span
                  ><span data-v-119184d8="" class="operation delete"
                    ><svg data-v-338e1447="" data-v-119184d8="" aria-hidden="true" class="svg-icon deleteIcon">
                      <use data-v-338e1447="" xlink:href="#icon-delete"></use></svg
                    >删除
                  </span>
                </div>
              </div>
            </div>
            <div data-v-119184d8="" class="rightOption">
              <div data-v-119184d8="" class="rbox">
                <label data-v-119184d8="" class="container">
                  <input data-v-119184d8="" name="fundingType" value="CNY" type="radio" checked="" />
                  <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">CNY资产</span></label
                >
              </div>
            </div>
          </div>
          <div data-v-119184d8="" class="dcontent">
            <div data-v-119184d8="" class="recordDetails">
              <div data-v-119184d8="" v-if="showtype == 0">
                <div data-v-2e25a862="" data-v-119184d8="" class="depositTable">
                  <div data-v-2e25a862="" class="thead">
                    <div data-v-2e25a862="" class="th">时间</div>
                    <div data-v-2e25a862="" class="th" v-if="type == 1 || type == 2">订单号</div>
                    <div data-v-2e25a862="" class="th">交易类型</div>
                    <div data-v-2e25a862="" class="th">金额</div>
                    <div data-v-2e25a862="" class="th">状态</div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length > 0">
                    <div data-v-11bca73b="" class="item" v-for="(item, index) in dataList" :key="index">
                      <div data-v-11bca73b="" class="set1">
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.created_at }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td" v-if="type == 1 || type == 2">
                          <span data-v-11bca73b="">{{ item.out_trade_no }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.pay_way }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.amount }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">
                            <span class="green" v-if="type == 1 || type == 2">{{ stateType12[item.state] }}</span>
                            <span class="green" v-if="type == 3 || type == 4">{{ stateType34[item.state] }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length == 0">
                    <div data-v-2e25a862="" class="noRecord">
                      <div data-v-2e25a862="" class="img"></div>
                      <div data-v-2e25a862="" class="txt">暂无记录</div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" v-if="showtype == 1">
                <div data-v-2e25a862="" data-v-119184d8="" class="depositTable">
                  <div data-v-2e25a862="" class="thead">
                    <div data-v-2e25a862="" class="th">时间</div>
                    <div data-v-2e25a862="" class="th">订单号</div>
                    <div data-v-2e25a862="" class="th">游戏名称</div>
                    <div data-v-2e25a862="" class="th">金额</div>
                    <div data-v-2e25a862="" class="th">派彩</div>
                    <div data-v-2e25a862="" class="th">状态</div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length > 0">
                    <div data-v-11bca73b="" class="item" v-for="(item, index) in dataList" :key="index">
                      <div data-v-11bca73b="" class="set1">
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.bet_time }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.bet_id }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.Code }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.bet_amount }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.win_loss }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">
                            <span class="green">{{ statuType[item.status] }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length == 0">
                    <div data-v-2e25a862="" class="noRecord">
                      <div data-v-2e25a862="" class="img"></div>
                      <div data-v-2e25a862="" class="txt">暂无记录</div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" v-if="showtype == 2">
                <div data-v-2e25a862="" data-v-119184d8="" class="depositTable">
                  <div data-v-2e25a862="" class="thead">
                    <div data-v-2e25a862="" class="th">游戏名称</div>
                    <div data-v-2e25a862="" class="th">返水金额</div>
                    <div data-v-2e25a862="" class="th">状态</div>
                    <div data-v-2e25a862="" class="th">返水时间</div>
                    <div data-v-2e25a862="" class="th">领取时间</div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length > 0">
                    <div data-v-11bca73b="" class="item" v-for="(item, index) in dataList" :key="index">
                      <div data-v-11bca73b="" class="set1">
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.gamename }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.money }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.state == 0 ? '待领取' : '已领取' }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.created_at }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">
                            <span class="green">{{ item.state == 0 ? '暂未领取' : item.updated_at }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length == 0">
                    <div data-v-2e25a862="" class="noRecord">
                      <div data-v-2e25a862="" class="img"></div>
                      <div data-v-2e25a862="" class="txt">暂无记录</div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" v-if="showtype == 3">
                <div data-v-2e25a862="" data-v-119184d8="" class="depositTable">
                  <div data-v-2e25a862="" class="thead">
                    <div data-v-2e25a862="" class="th">充值金额</div>
                    <div data-v-2e25a862="" class="th">红包金额</div>
                    <div data-v-2e25a862="" class="th">充值时间</div>
                    <div data-v-2e25a862="" class="th">领取时间</div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="redpacketList.length > 0">
                    <div data-v-11bca73b="" class="item" v-for="(item, index) in redpacketList" :key="index">
                      <div data-v-11bca73b="" class="set1">
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.money }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.redpacketmoney }}</span>
                        </div>

                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.created_at }}</span>
                        </div>

                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.usetime }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="redpacketList.length == 0">
                    <div data-v-2e25a862="" class="noRecord">
                      <div data-v-2e25a862="" class="img"></div>
                      <div data-v-2e25a862="" class="txt">暂无记录</div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-2fe78b6a="" class="controls" v-if="redpacketShowData.total">
                <el-pagination style="margin: 20px 0 0px 120px" @current-change="getredpacket" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="redpacketShowData.total"></el-pagination>
              </div>
            </div>

            <div data-v-119184d8="" class="typeBox">
              <div data-v-119184d8="" class="box" v-if="showtype != 3">
                <h1 data-v-119184d8="">交易平台</h1>
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <select style="width: 145px; height: 30px" v-model="api_type" @change="typeChang">
                        <option :value="''">全平台</option>
                        <option v-for="(item, index) in dogameLis" :key="index" :value="item.platname">{{ item.name }}</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" class="box" v-if="showtype == 0">
                <h1 data-v-119184d8="">交易类型</h1>
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="type" v-model="type" value="1" checked="" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">存款</span></label
                    >
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="type" v-model="type" value="2" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">取款</span></label
                    >
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="type" v-model="type" value="3" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">转入</span></label
                    >
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="type" v-model="type" value="4" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">转出</span></label
                    >
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" class="box" v-if="showtype != 3">
                <h1 data-v-119184d8="">交易时间</h1>
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="date" v-model="date" value="1" checked="" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">今日</span></label
                    >
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="date" v-model="date" value="2" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">一周内</span></label
                    >
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="date" v-model="date" value="3" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">半月内</span></label
                    >
                    <label data-v-119184d8="" class="container">
                      <input data-v-119184d8="" type="radio" name="date" v-model="date" value="4" />
                      <span data-v-119184d8="" class="checkmark"></span><span data-v-119184d8="" class="txt">一月内</span></label
                    >
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" class="box" v-if="showtype == 2">
                <h1 data-v-119184d8="">返水情况</h1>
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <span data-v-119184d8="" class="txt"
                        >累计领取 <span style="color: yellow">{{ jisuan }}</span></span
                      ></label
                    >
                    <label data-v-119184d8="" class="container" @click="lingqu">
                      <span data-v-119184d8="" class="txt"
                        >待领取 <span style="color: yellow">{{ nojisuan }}</span></span
                      ></label
                    >
                    <label data-v-119184d8="" class="container" v-if="nojisuan"> <span @click="lingqu" data-v-119184d8="" class="txt">点击领取返水</span></label>
                  </div>
                </div>
              </div>
              <div data-v-119184d8="" class="box" v-if="showtype == 3">
                <h1 data-v-119184d8="">红包情况</h1>
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <span data-v-119184d8="" class="txt"
                        >累计领取次数 <span style="color: yellow">{{ userredpacket.sendnums }}</span></span
                      ></label
                    >
                    <label data-v-119184d8="" class="container" @click="$parent.goNav('/userredpacket')">
                      <span data-v-119184d8="" class="txt"
                        >剩余领取次数 <span style="color: yellow">{{ userredpacket.acquirednum }}</span></span
                      ></label
                    >
                    <label data-v-119184d8="" class="container"> <span @click="$parent.goNav('/userredpacket')" data-v-119184d8="" class="txt">前往领取红包</span></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fundingRecords',
  data() {
    return {
      date: 1,
      type: 1,
      page: 1,
      api_type: '',
      stateType12: ['未定义', '待审核', '审核通过', '审核拒绝'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
      statuType: ['无效注单', '已结算', '未结算'],
      showData: {},
      dataList: [],
      showtype: 0,
      jisuan: 0,
      nojisuan: 0,
      dogameLis: [],
      redpacketList: [],
      redpacketShowData: {},
      userredpacket: {},
    };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.type) {
      that.showtype = query.type;
    }
    that.getdogame();
  },
  methods: {
    typeChang() {
      let that = this;
      console.log(123);
      that.page = 1;

      that.getData();
    },
    getdogame() {
      let that = this;
      that.$apiFun.post('/api/balancelist', {}).then(res => {
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.getData();
        }
      });
    },
    lingqu() {
      let that = this;
      let fanshui = that.nojisuan;
      if (fanshui <= 0) {
        that.$parent.showTost(0, '暂无领取额度！');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          that.$parent.getUserInfo();
          that.$parent.showTost(1, res.message);
          that.getData();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changshowtype(val) {
      let that = this;
      if (val == that.showtype) {
        return;
      }
      that.page = 1;
      that.showtype = val;
      that.getData();
    },
    getwelfare() {
      let that = this;
      if (that.userredpacket.sendnums < 1) {
        that.$parent.showTost(0, '您的剩余次数不足！');

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);

          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.getredpacket();
          that.getuserredpacket();
        })
        .catch(() => {
          that.$parent.showTost(0, '服务器异常，请稍后再试');
          that.$parent.hideLoading();
        });
    },

    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.get('/api/userredpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    getredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.post('/api/redpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.redpacketList = res.data.data;
          that.redpacketShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    getData() {
      let that = this;
      that.$parent.showLoading();
      let info = {};
      let url = '';

      if (that.showtype == 0) {
        info = {
          date: that.date,
          type: that.type,
          page: that.page,
          api_type: that.api_type,
        };
        url = '/api/gettransrecord';
      }
      if (that.showtype == 1) {
        url = '/api/betrecord';

        info = {
          date: that.date,
          // type: that.type,
          page: that.page,
          api_type: that.api_type,
        };
      }
      if (that.showtype == 2) {
        url = '/api/getfanshui';
        info = {
          date: that.date,
          type: '',
          page: that.page,
          api_type: that.api_type,
        };
      }
      if (that.showtype == 3) {
        that.getredpacket();
        that.getuserredpacket();

        return;
      }
      console.log(info);
      that.$apiFun
        .post(url, info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            if (that.showtype == 2) {
              that.jisuan = res.data.jisuan;
              that.nojisuan = res.data.nojisuan;
              that.dataList = res.data.list.data;
              that.showData = res.data.list;
            } else {
              that.dataList = res.data.data;
              that.showData = res.data;
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  watch: {
    date() {
      let that = this;
      that.page = 1;
      that.getData();
    },
    type() {
      let that = this;
      that.page = 1;
      that.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-29b951e4.0bcca33f.css';
/* 资金记录核心区域 - 改为白色背景 */
.fundingRecords[data-v-119184d8] {
    width: 100%;
    height: 100%;
    background: #ffffff; /* 改为白色背景 */
    -webkit-box-shadow: 0 .01rem .03rem 0 rgba(0,0,0,.1); /* 减轻阴影 */
    box-shadow: 0 .01rem .03rem 0 rgba(0,0,0,.1);
    border-radius: .08rem;
    padding-bottom: .3rem;
    padding-top: .3rem;
    color: #333333; /* 基础文本色改为深灰 */
}

/* 顶部菜单文本颜色调整 */
.fundingRecords .topTxt .menu span[data-v-119184d8] {
    color: #666666; /* 未选中菜单文本色 */
}

.fundingRecords .topTxt .menu span.active[data-v-119184d8] {
    color: #333333; /* 选中菜单文本色 */
}

/* 操作按钮颜色调整 */
.fundingRecords .topTxt .menu .operation[data-v-119184d8] {
    border: 1px solid #cccccc;
    color: #333333;
}

.fundingRecords .topTxt .menu .operation.delete[data-v-119184d8] {
    color: #ff4d4f;
    border: 1px solid #ff4d4f;
}

/* 表格头部样式调整 */
.fundingRecords[data-v-119184d8] .recordDetails .thead {
    background: #f5f5f5; /* 表头浅灰背景 */
}

.fundingRecords[data-v-119184d8] .recordDetails .thead .th {
    color: #666666; /* 表头文本色 */
}

/* 表格内容区域样式调整 */
.fundingRecords[data-v-119184d8] .recordDetails .recordList .item {
    background: #ffffff; /* 表格行白色背景 */
    border-bottom: 1px solid #f0f0f0; /* 分隔线 */
}

.fundingRecords[data-v-119184d8] .recordDetails .recordList .item:nth-of-type(2n) {
    background: #fafafa; /* 交替行浅灰背景 */
}

.fundingRecords[data-v-119184d8] .recordDetails .recordList .item .set1 .td {
    color: #333333; /* 表格内容文本色 */
}

/* 无记录状态样式 */
.fundingRecords[data-v-119184d8] .recordDetails .recordList .noRecord {
    background: #ffffff;
}

.fundingRecords[data-v-119184d8] .recordDetails .recordList .noRecord .txt {
    color: #666666;
}

/* 筛选框样式调整 */
.fundingRecords .typeBox .box[data-v-119184d8] {
    background: #f9f9f9; /* 筛选框浅灰背景 */
}

.fundingRecords .typeBox .box h1[data-v-119184d8] {
    color: #333333; /* 标题文本色 */
    border-bottom: .01rem solid #eeeeee;
}

/* 单选框样式调整 */
.fundingRecords .cbox .container[data-v-119184d8],
.fundingRecords .rbox .container[data-v-119184d8] {
    color: #333333; /* 选项文本色 */
}
.fundingRecords .typeBox .rbox select {
    width: 145px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: #fff;
    font-size: 14px;
    color: #333;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23666' d='M6 8L0 0h12L6 8z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    cursor: pointer;
    transition: border-color 0.2s ease;
}
.fundingRecords .cbox .checkmark[data-v-119184d8],
.fundingRecords .rbox .checkmark[data-v-119184d8] {
    border: 1px solid #cccccc;
}

.fundingRecords .cbox .container input:checked~.txt[data-v-119184d8],
.fundingRecords .rbox .container input:checked~.txt[data-v-119184d8] {
    color: #2c6ecb; /* 选中选项文本色 */
}

.fundingRecords .cbox .container input:checked~.checkmark[data-v-119184d8],
.fundingRecords .rbox .container input:checked~.checkmark[data-v-119184d8] {
    border-color: #2c6ecb;
}

.fundingRecords .rbox .container .checkmark[data-v-119184d8]:after {
    background: #2c6ecb; /* 单选框选中填充色 */
}

/* 分页控件样式 */
.fundingRecords[data-v-119184d8] .recordDetails .controls .btn {
    border: 1px solid #2c6ecb;
    color: #2c6ecb;
}

.fundingRecords[data-v-119184d8] .recordDetails .controls .pager {
    color: #666666;
}

.fundingRecords[data-v-119184d8] .recordDetails .controls .pager .sbox {
    border: 1px solid #dddddd;
    color: #666666;
}

.fundingRecords[data-v-119184d8] .recordDetails .controls .pager .sbox.active {
    border-color: #2c6ecb;
    color: #2c6ecb;
}
    
</style>



// WEBPACK FOOTER //
// src/components/mode/fundingRecords.vue